module.exports = __webpack_public_path__ + "static/media/about-bilgoraj-poster-1.75dba6c4.png";